import { useEffect } from 'react';
import { type IFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { Layer } from '../..';
import { LayerHotkeyType } from '../../type';

export function useLockLayerHotkey(framework: IFramework) {
    useEffect(() => {
        const { $t } = getLocaleStore();
        const controller = new Layer(framework.identity);
        framework.service.hotkey.register({
            name: $t((v) => v.Text_LockLayer),
            win: 'Shift Ctrl L',
            mac: '⇧ ⌘ L',
            key: LayerHotkeyType.LOCK,
            processors: [
                {
                    press: ['Shift+Command+L', 'Shift+Ctrl+L'],
                    fn: () => {
                        const activeLayer = framework.service.frame.getActiveLayer();
                        if (!activeLayer) return;
                        if (activeLayer.lock) {
                            controller.unlock(activeLayer.id);
                        } else {
                            controller.lock(activeLayer.id);
                        }
                    },
                },
            ],
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps -- 仅挂载时注册，与拆分前一致
    }, []);
}
